// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"ae0c31e3","447":"f2a935e0","453":"ce513f15","487":"90a007f7","507":"4b879770","561":"71b7353f","863":"d1b00e92","903":"13563d78"}[chunkId] + ".chunk.js";
};